"use client"

import { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

import { Button } from "../ui/button"
import { Checkbox } from "../ui/checkbox"

export default function NavChoice({
  selectedItems,
  name,
  Icon,
  ...props
}: HTMLAttributes<HTMLButtonElement> & {
  selectedItems: string[]
  name: string
  Icon: any
}) {
  return (
    <Button
      {...props}
      variant="navbar-choice"
      className={cn("flex items-center justify-start gap-3", props.className, {
        "!bg-neutral-200": selectedItems.includes(name),
      })}
    >
      <Icon className="h-8 w-8 shrink-0" />
      <p className="text-main-black">{name}</p>
      <div className="flex grow justify-end">
        <Checkbox aria-label={name} checked={selectedItems.includes(name)} name={name} />
      </div>
    </Button>
  )
}
